import React from "react";
var __jsx = React.createElement;
import Image from '@anm/components/image/Image';
import { LogoWrapper } from './Wrapper';

var CustomLogo = function CustomLogo(_ref) {
  var alt = _ref.alt,
      logoUrl = _ref.logoUrl;
  return __jsx(LogoWrapper, null, __jsx(Image, {
    src: logoUrl,
    alt: alt
  }));
};

export default CustomLogo;